import { render, staticRenderFns } from "./home-links.vue?vue&type=template&id=47dddf2a&scoped=true&"
import script from "./home-links.vue?vue&type=script&lang=js&"
export * from "./home-links.vue?vue&type=script&lang=js&"
import style0 from "./home-links.vue?vue&type=style&index=0&id=47dddf2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dddf2a",
  null
  
)

export default component.exports